import { render, staticRenderFns } from "./TestsOfStudent.vue?vue&type=template&id=4ddd1ab7&"
import script from "./TestsOfStudent.vue?vue&type=script&lang=js&"
export * from "./TestsOfStudent.vue?vue&type=script&lang=js&"
import style0 from "./TestsOfStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports